import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview-header center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Preview", -1 /* HOISTED */)
const _hoisted_4 = { class: "close" }
const _hoisted_5 = { class: "offer-container flex-center" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"header\"><div class=\"description\">You&#39;ve received an</div><div class=\"title center\"><span class=\"logo center\"><svg class=\"icon opt-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1780 960\"><defs><clipPath id=\"clip_opt-icon\"><rect width=\"1780\" height=\"960\" style=\"fill:none;\"></rect></clipPath></defs><g style=\"clip-path:url(#clip_opt-icon);\"><path class=\"icon-path filled\" d=\"M1091,148c-162.47,0-295,132.65-295,295.28V904.63c0,30,25.35,55.37,55.31,55.37s55.32-25.38,55.32-55.37V674c50.7,40.38,114.08,64.6,184.37,64.6,162.47,0,295-132.65,295-295.27S1253.47,148,1091,148m0,479.82c-101.41,0-184.37-83-184.37-184.54s83-184.55,184.37-184.55,184.37,83,184.37,184.54-83,184.55-184.37,184.55\"></path><path class=\"icon-path filled\" d=\"M1724.66,627.29h-55.33a110.7,110.7,0,0,1-110.66-110.7V258.3h166c30,0,55.34-25.37,55.34-55.36s-25.36-55.35-55.34-55.35h-166V55.34c0-30-25.36-55.34-55.34-55.34S1448,25.36,1448,55.34V516.59C1448,638.84,1547.13,738,1669.33,738h55.33c30,0,55.34-25.37,55.34-55.35s-25.36-55.36-55.34-55.36\"></path><path class=\"icon-path filled\" d=\"M369,0C164.9,0,0,164.89,0,369S164.9,738,369,738,738,573.1,738,369,573.1,0,369,0m0,627.29C226.34,627.3,110.69,511.66,110.68,369S226.31,110.7,369,110.69,627.29,226.32,627.29,369v0c.24,142.41-115,258-257.43,258.29H369\"></path><path class=\"icon-path filled\" d=\"M393.47,356.5V175.3a31.18,31.18,0,1,0-62.35,0V382L475.73,529.58a31.18,31.18,0,0,0,44.54-43.65Z\"></path></g></svg></span><span class=\"invite-text\">| Invite</span></div></div>", 1)
const _hoisted_7 = {
  key: 0,
  class: "offer-card center"
}
const _hoisted_8 = { class: "from" }
const _hoisted_9 = { class: "sender" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "request" }, "has offered", -1 /* HOISTED */)
const _hoisted_11 = { class: "offer-amount" }
const _hoisted_12 = { class: "currency" }
const _hoisted_13 = { class: "amount" }
const _hoisted_14 = { class: "description" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "for" + /*#__PURE__*/_toDisplayString(' '), -1 /* HOISTED */)
const _hoisted_16 = { class: "duration" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(' ') + "of your time", -1 /* HOISTED */)
const _hoisted_18 = {
  key: 1,
  class: "offer-card center"
}
const _hoisted_19 = { class: "from" }
const _hoisted_20 = { class: "sender" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "request" }, "has requested", -1 /* HOISTED */)
const _hoisted_22 = { class: "offer-amount" }
const _hoisted_23 = { class: "currency" }
const _hoisted_24 = { class: "amount" }
const _hoisted_25 = { class: "description" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "for" + /*#__PURE__*/_toDisplayString(' '), -1 /* HOISTED */)
const _hoisted_27 = { class: "duration" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(' ') + "of their time", -1 /* HOISTED */)
const _hoisted_29 = {
  key: 2,
  class: "note"
}
const _hoisted_30 = {
  key: 0,
  class: "icon-header"
}
const _hoisted_31 = { class: "user-icon" }
const _hoisted_32 = { class: "profile" }
const _hoisted_33 = {
  key: 0,
  class: "profile-container"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "profile-container"
}
const _hoisted_36 = { class: "profile-initials" }
const _hoisted_37 = {
  key: 2,
  class: "profile-container"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon profile",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "filled",
    d: "M50 0C40 0 30.4 2.9 22.2 8.4C14 14 7.6 21.7 3.8 30.9C0 40 -0.97 50 0.96 59.7546C2.89002 69.4536 7.65222 78.3628 14.6449 85C21.6 92.3 30.5464 97 40 99C50 101 60 100 69.1 96.2C78.3 92.4 86 86.0 91.6 77.8C97.1 69.6 100 60 100 50C100 36.74 94.7263 24 85.3505 14.6497C75.9747 5.27383 63.2594 0.00454376 50 0M50 15C52.9667 15 55.8668 15.8797 58.3335 17.528C60.8003 19.1762 62.7231 21.5189 63.8584 24.2598C65 27.0007 65.2907 30.0166 64.7119 32.9264C64.1331 35.8361 62.7046 38.5089 60.6068 40.6066C58.509 42.7044 55.8362 44.1331 52.9265 44.7118C50.0168 45.29 47.0007 45 44.2598 43.8582C41.519 42.7229 39.1764 40.8003 37.5282 38.3336C35.88 35.8668 35 32.9668 35 30C35 28.0 35.3837 26.0777 36.1366 24.2567C36.8895 22.4356 38 20.7809 39.3875 19.3875C40.7809 18 42.4356 16.8893 44.2567 16.1364C46.0778 15.3836 48.0294 15 50 15M50 86C44.0592 86 38.2109 84.53 32.9764 81.7208C27.7418 78.9116 23.2838 74.85 20 69.9C20.1513 60 40 54.50 50 54.5C59.9485 54.50 79.8486 60 80 69.9C76.7 74.85 72.2584 78.9116 67.0239 81.7208C61.7894 84.53 55.9407 86 50 86"
  })
], -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 3,
  class: "offer-spacer"
}
const _hoisted_41 = { class: "button-offer" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 1,
  class: "offer-page"
}
const _hoisted_44 = { class: "error-body" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "error-header" }, "An Unexpected Error Occurred", -1 /* HOISTED */)
const _hoisted_46 = { class: "error-description" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Opt Profile")
const _hoisted_48 = {
  key: 2,
  class: "offer-page flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.offer && $setup.person && !$props.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["offer-page", { preview: $props.isPreview }])
      }, [
        ($props.isPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "borderless",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('close')))
                }, "Close")
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          ($setup.offerType == 'payer')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.person.name.fullName) + _toDisplayString(' '), 1 /* TEXT */),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.offer.price.currency), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_13, _toDisplayString($setup.offer.price.amount), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString($setup.offer.minutes) + " Minutes", 1 /* TEXT */),
                  _hoisted_17
                ])
              ]))
            : ($setup.offerType == 'collector')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString($setup.person.name.fullName) + _toDisplayString(' '), 1 /* TEXT */),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString($setup.offer.price.currency), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_24, _toDisplayString($setup.offer.price.amount), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("span", _hoisted_27, _toDisplayString($setup.offer.minutes) + " Minutes", 1 /* TEXT */),
                    _hoisted_28
                  ])
                ]))
              : _createCommentVNode("v-if", true),
          ($setup.offer.note)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: _normalizeClass(["description-note", {smallNote:$setup.checkNoteLength($setup.offer.note.length)}])
                }, _toDisplayString($setup.offer.note), 3 /* TEXT, CLASS */),
                ($setup.person)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          ($setup.person?.profilePic)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("img", {
                                  class: "profile-pic",
                                  src: $setup.person.profilePic
                                }, null, 8 /* PROPS */, _hoisted_34)
                              ]))
                            : ($setup.person?.name?.firstName && $setup.person?.name?.lastName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString($setup.person.name.firstName[0] + $setup.person.name.lastName[0]), 1 /* TEXT */)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40))
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("button", {
            class: "primary",
            disabled: $props.isPreview,
            onClick: $setup.scheduleMeeting
          }, "Schedule Meeting", 8 /* PROPS */, _hoisted_42)
        ])
      ], 2 /* CLASS */))
    : ($setup.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, _toDisplayString($setup.error), 1 /* TEXT */),
            _createVNode(_component_router_link, {
              class: "error-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createVNode($setup["Loader"], { "full-screen": false })
        ]))
}